var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"mr-2",attrs:{"variant":"primary"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarAtivarDesativarUsuario()}}},[_vm._v(_vm._s(_vm.operacaoBtn)+" Usuário")])
}
var staticRenderFns = []

export { render, staticRenderFns }